import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cleanName',
  standalone: true,
})
export class CleanNamePipe implements PipeTransform {

  constructor() {
  }

  transform(text: string, args?: any): string {
    return text.replace(/_/g, ' ');
  }
}
